import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    id: 1,
    name: 'Alex Johnson',
    role: 'Executive Chef',
    company: 'Riverside Restaurant',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&h=200&q=80',
    quote: 'I found my dream job as an Executive Chef through CateringCareers. The platform made it easy to connect with top restaurants in my area.'
  }, {
    id: 2,
    name: 'Sarah Williams',
    role: 'Catering Manager',
    company: 'Elite Events',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&h=200&q=80',
    quote: "As a hiring manager, CateringCareers has transformed our recruitment process. We've found exceptional talent that perfectly matches our company culture."
  }, {
    id: 3,
    name: 'Michael Chen',
    role: 'Pastry Chef',
    company: 'Sweet Delights Bakery',
    image: 'https://images.unsplash.com/photo-1566492031773-4f4e44671857?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=200&h=200&q=80',
    quote: "The specialized focus on catering jobs helped me find a position that perfectly matched my pastry skills. I'm now working at my dream bakery!"
  }];
  return <section className="py-16 bg-amber-50" data-id="element-212">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-213">
        <div className="text-center mb-16" data-id="element-214">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-215">Success Stories</h2>
          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-216">
            Hear from professionals and employers who found success with
            CateringCareers
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-217">
          {testimonials.map(testimonial => <div key={testimonial.id} className="bg-white p-6 rounded-lg shadow-md" data-id="element-218">
              <div className="flex items-center mb-4" data-id="element-219">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover mr-4" data-id="element-220" />
                <div data-id="element-221">
                  <h3 className="font-semibold text-lg text-gray-900" data-id="element-222">
                    {testimonial.name}
                  </h3>
                  <p className="text-gray-600 text-sm" data-id="element-223">
                    {testimonial.role}, {testimonial.company}
                  </p>
                </div>
              </div>
              <div className="flex mb-4" data-id="element-224">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-225" />)}
              </div>
              <p className="text-gray-700 italic" data-id="element-226">
                &ldquo;{testimonial.quote}&rdquo;
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}